import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import styles from "./index.module.css";
import TopContainer from "./topContainer";
import BottomContainer from "./bottomContainer";

const PRODUCTS_JSON_URL =
  "https://epinics-public-assets.s3.ap-south-1.amazonaws.com/offcial-site-assets/data/products.json";

const getProductTag = (title = "") => {
  const lower = title.toLowerCase();
  if (lower.includes("scanner")) return "Scanner";
  if (lower.includes("printer")) return "Printer";
  if (lower.includes("monitor") || lower.includes("display")) return "Display";
  if (lower.includes("drawer")) return "Storage";
  if (lower.includes("mouse") || lower.includes("keyboard")) return "Peripheral";
  if (lower.includes("system") || lower.includes("unit") || lower.includes("pc"))
    return "Computer";
  return "Hardware";
};

const cardVariants = {
  hidden: { opacity: 0, y: 28 },
  visible: (index) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      ease: [0.22, 1, 0.36, 1],
      delay: (index % 4) * 0.08,
    },
  }),
};

const PcFullSet = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(PRODUCTS_JSON_URL)
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to load products (${res.status})`);
        return res.json();
      })
      .then((data) => {
        setProducts(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        console.log(err);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <TopContainer products={products} />
      <div id="catalog" className={styles.catalogContainer}>
        <div className={styles.catalogHeader}>
          <h2 className={styles.catalogTitle}>Hardware</h2>
          <p className={styles.catalogSubtitle}>
            Explore our store for high-quality products designed with precision,
            innovation, and care. Discover items that blend style, functionality,
            and excellence.
          </p>
        </div>

        {error && (
          <div className={styles.errorState}>Couldn't load products: {error}</div>
        )}

        <div className={styles.productsGrid}>
          {loading
            ? Array.from({ length: 8 }).map((_, index) => (
                <div className={styles.productCard} key={`skeleton-${index}`}>
                  <div
                    className={`${styles.imageContainer} ${styles.skeletonBlock}`}
                  />
                  <div className={styles.productInfo}>
                    <div
                      className={`${styles.skeletonLine} ${styles.skeletonPrice}`}
                    />
                    <div
                      className={`${styles.skeletonLine} ${styles.skeletonTitle}`}
                    />
                    <div
                      className={`${styles.skeletonLine} ${styles.skeletonSpec}`}
                    />
                    <div
                      className={`${styles.skeletonLine} ${styles.skeletonSpecShort}`}
                    />
                  </div>
                </div>
              ))
            : !error &&
              products.map((product, index) => {
                const showPrice =
                  product.price != null && Number(product.price) !== 0;

                return (
                  <motion.div
                    className={styles.productCard}
                    key={product.title || index}
                    custom={index}
                    variants={cardVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    whileHover={{ y: -4 }}
                    transition={{ type: "spring", stiffness: 320, damping: 24 }}
                  >
                    <div className={styles.imageContainer}>
                      <img
                        src={product.image_url}
                        alt={product.title}
                        className={styles.productImage}
                      />
                      <span className={styles.productTag}>
                        {getProductTag(product.title)}
                      </span>
                    </div>
                    <div className={styles.productInfo}>
                      {showPrice && (
                        <div className={styles.productPrice}>
                          {`LKR ${Number(product.price).toLocaleString()}`}
                        </div>
                      )}
                      <h3 className={styles.productName}>{product.title}</h3>
                      {(product.description || []).length > 0 && (
                        <ul className={styles.productDescription}>
                          {(product.description || []).map((line, i) => (
                            <li key={i}>{line}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </motion.div>
                );
              })}
        </div>
        <a
          className={styles.quotationLink}
          href="https://web.whatsapp.com/send?phone=94741041212&text=Hello%2C%20I%20would%20like%20to%20get%20a%20quotation%20for%20your%20POS%20hardware.%20Could%20you%20please%20assist%20me%3F"
          target="_blank"
          rel="noopener noreferrer"
        >
        <div className={styles.getQuotationBtn}>Get Quotation</div>
      </a>
      </div>
      <BottomContainer />
    </>
  );
};

export default PcFullSet;
